<div class="pc-card"
     [class.pc-card--clickable]="clickable()"
     (click)="cardClick.emit()">
  <div class="pc-pos-badge"
       [class]="normPos(player().position)"
       [style.background]="posColor() || null">
    {{ player().position }}
  </div>
  <div class="pc-art" [class.pc-art--empty]="!showPhoto()">
    @if (showPhoto()) {
      @if (player().photo) {
        <img [src]="player().photo"
             [alt]="player().firstName + ' ' + player().lastName"
             loading="lazy" />
      } @else {
        <svg width="36" height="36" viewBox="0 0 100 100" style="opacity:0.18">
          <circle cx="50" cy="34" r="18" fill="currentColor"/>
          <path d="M10 100 Q10 62 50 62 Q90 62 90 100 Z" fill="currentColor"/>
        </svg>
      }
    }
  </div>
  <div class="pc-footer">
    <div class="pc-name">
      @if (nameAbbrev()) {
        {{ player().firstName[0] }}. {{ player().lastName }}
      } @else {
        {{ player().firstName }} {{ player().lastName }}
      }
    </div>
    <div class="pc-meta">
      <span class="pc-team">{{ player().team }}</span>
      <span class="pc-cost">{{ player().cost != null ? '$' + player().cost : '' }}</span>
    </div>
  </div>
</div>
